import(/* webpackMode: "eager" */ "/build/app/(bank)/error.tsx");
